/** @jsx jsx */
import { jsx } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import ProductRoadMapProjectIconUrl from '../assets/template-roadmap-icon.svg';

const ProductRoadmapProjectAvatar = (): JSX.Element => {
	return (
		<Avatar
			appearance="square"
			borderColor="transparent"
			size="small"
			src={ProductRoadMapProjectIconUrl}
		/>
	);
};
export default ProductRoadmapProjectAvatar;
